const validateResponse = async (response, text) => {
  const responseType = response.headers.get('Content-Type') || ''
  if (responseType.includes('text/html') || !text || text.includes('<html') || text.includes('<!DOCTYPE html')) {
    return false
  }
  return true
}

/** @function
 * * fetch the markdown file from the server
 * @name handlingResponse
 * @param {string} bank - The bank code
 * @param {string} language - The language code
 * @return {string | undefined} -
 */
export const fetchMarkdown = async (fileName, bank, language, callback) => {
  const headers = {
    'Content-Type': 'text/markdown',
    Accept: 'text/markdown'
  }

  try {
    let response
    let text = ''
    if (process.env.ISMOCK === 'true') {
      response = await fetch(`/${fileName}`, { headers })
      text = await response.text()
    } else {
      response = await fetch(`${window.location.origin}${process.env.STATIC_DOC}${bank}/${language}/${fileName}`, {
        headers
      })
      text = await response.text()
      const isValidResponse = await validateResponse(response, text)
      if (!response.ok || !isValidResponse) {
        response = await fetch(`${window.location.origin}${process.env.STATIC_DOC}${bank}/en/${fileName}`, {
          headers
        })
        text = await response.text()
        const isValidFallback = await validateResponse(response, text)
        if (!response.ok || !isValidFallback) {
          throw new Error('resource unavailable')
        }
      }
    }
    callback(text)
    return text
  } catch (error) {
    console.error('Error fetching markdown:', error)
    callback(undefined)
    return undefined
  }
}
